import { render, staticRenderFns } from "./EmployeeReviewCounterBlock.vue?vue&type=template&id=07c7fdb2"
import script from "./EmployeeReviewCounterBlock.vue?vue&type=script&lang=js"
export * from "./EmployeeReviewCounterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports